import { forwardRef, memo, useState } from 'react';
import ModalDialog from '../../../../../components/Modal/Dialog';
import { PlantelViewResult } from '../../../../../components/Widgets/GamePlanField/PlantelViewResult';

interface OptionItemProps {
	item: any;
	index: number;
	status: any;
}

const OptionItemView = memo(
	forwardRef<HTMLDivElement, OptionItemProps>(
		({ item, index, status }, ref) => {
			const [openModalIndex, setOpenModalIndex] = useState(false);
			const renderOption = (optionType: number) => {
				switch (optionType) {
					case 0:
						return (
							<div className="w-full flex flex-col gap-2">
								{item.isCanceled ? (
									<div className="justify-end items-center gap-2 inline-flex">
										<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]">
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Cancelado
											</div>
										</div>
									</div>
								) : item.resultStatus === 1 ? (
									<div className="justify-end items-center gap-2 inline-flex">
										<div
											className={
												'w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex ' +
												(item.statementResult
													? 'bg-[#0ea25d]'
													: 'bg-[#a20e0e]')
											}
										>
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												{item.isCanceled
													? 'Cancelado'
													: item.statementResult
													? 'Sim'
													: 'Não'}
											</div>
										</div>
									</div>
								) : (
									<div className="justify-end items-center gap-2 inline-flex">
										<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]">
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Pendente
											</div>
										</div>
									</div>
								)}
							</div>
						);
					case 1:
						return (
							<div
								className={
									'flex gap-[5px] ' +
									(status === 1 || status === 3
										? 'flex-col justify-between'
										: 'justify-end')
								}
							>
								{item.isCanceled ? (
									<div className="justify-end items-center gap-2 inline-flex">
										<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]">
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Cancelado
											</div>
										</div>
									</div>
								) : status === 1 || status === 3 ? (
									Array.isArray(item.draftResult) &&
									item.draftResult.length > 0 ? (
										Array.isArray(item.draftResult[0]) ? (
											<>
												<div
													onClick={() => {
														setOpenModalIndex(
															!openModalIndex
														);
													}}
													className="text-[#0ea25d] text-center text-xs font-semibold font-bahnschrift underline cursor-pointer"
												>
													Veja aqui as escalações
													vencedoras
												</div>
												<ModalDialog
													id={'modalDraftResult'}
													open={openModalIndex}
													title="Escalações vencedoras"
													onClose={() =>
														setOpenModalIndex(
															!openModalIndex
														)
													}
												>
													<div
														key={index}
														className="px-6 pb-6 flex flex-col gap-4 overflow-y-scroll max-h-[75vh] mb-4"
													>
														{item.draftResult.map(
															(
																group: any,
																i: number
															) => (
																<PlantelViewResult
																	key={i}
																	positions={
																		item.draftPositions
																	}
																	draftResult={
																		group
																	}
																	modalityName={
																		item
																			.modality
																			.name
																	}
																/>
															)
														)}
													</div>
												</ModalDialog>
											</>
										) : (
											<PlantelViewResult
												positions={item.draftPositions}
												draftResult={item.draftResult}
												modalityName={
													item.modality.name
												}
											/>
										)
									) : (
										<div className="justify-end items-center gap-2 inline-flex">
											<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]">
												<div className="text-white text-xs font-normal font-bahnschrift leading-3">
													Pendente
												</div>
											</div>
										</div>
									)
								) : (
									<div className="justify-end items-center gap-2 inline-flex">
										<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#ea8d27]">
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Pendente
											</div>
										</div>
									</div>
								)}
							</div>
						);
					case 2:
						return (
							<div
								className={
									'flex gap-[5px] ' +
									(item.resultStatus === 1
										? 'justify-between'
										: 'justify-end')
								}
							>
								{item.isCanceled ? (
									<div className="justify-end items-center gap-2 inline-flex">
										<div className="w-20 h-7 p-2 mt-1 rounded-lg justify-center items-center gap-2 inline-flex bg-[#a20e0e]">
											<div className="text-white text-xs font-normal font-bahnschrift leading-3">
												Cancelado
											</div>
										</div>
									</div>
								) : item.resultStatus === 1 ? (
									<div className="flex items-center gap-2 w-full">
										<div className="flex flex-col gap-2 text-[#0ea25d] text-xl text-center w-full font-semibold font-bahnschrift">
											<div>
												{item.numberResult}{' '}
												<span className="text-[#0ea25d] text-base text-center w-full font-semibold font-bahnschrift">
													{item.draftScout
														? Number(
																item.numberResult
														  ) <= 1
															? item.draftScout
																	.name
															: item.draftScout
																	.nameSuffix
														: ''}
												</span>
											</div>
										</div>
									</div>
								) : (
									<div className="w-20 h-7 p-2 rounded-lg mt-1 justify-center items-center gap-2 inline-flex bg-[#ea8d27]">
										<div className="text-white text-xs font-normal font-bahnschrift leading-3">
											Pendente
										</div>
									</div>
								)}
							</div>
						);
					default:
						return null;
				}
			};

			return (
				<div
					ref={ref}
					tabIndex={-1}
					key={index}
					className="flex flex-col w-full lg:max-w-screen-xl lg:mx-auto"
				>
					<div className="bg-gray-100 rounded-lg min-h-[116px]">
						<div className="flex flex-col gap-0.5 px-4 py-1.5">
							<div className="self-stretch justify-end items-center gap-2.5 inline-flex">
								<div
									className={
										'text-primary text-xs font-semibold font-bahnschrift' +
										(item.optionType === 0 ? '' : ' pt-1')
									}
								>
									{item.resultStatus === 1 &&
									item.optionType === 0
										? `${
												item.statementResult
													? item.winPointsYes
													: item.winPointsNo
										  } pontos`
										: ''}
								</div>
							</div>
							<div className="self-stretch flex-col justify-start items-start gap-0.5 flex">
								<div className="self-stretch flex-col justify-start items-start gap-1 flex">
									<div className="self-stretch text-custom-black text-base font-semibold font-bahnschrift min-h-12">
										{item.title}
									</div>
								</div>
							</div>

							{renderOption(item.optionType)}
						</div>
					</div>
				</div>
			);
		}
	)
);

export default OptionItemView;
